import { render, staticRenderFns } from "./EcardTemplateList.vue?vue&type=template&id=2140cb78&"
import script from "./EcardTemplateList.vue?vue&type=script&lang=js&"
export * from "./EcardTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports